import React from 'react';
import { withRouter } from 'react-router-dom';
import DataModel from '../../models/DataModel';
import MobileHeader from '../../components/MobileHeader';
import ProjectDetailsHeader from '../../components/ProjectDetailsHeader';
import DelayReportContainer from '../../containers/DelayReportContainer';
import dataModel from '../../models/DataModel';
import '../MobileWrapper.scss';
import './DelayViewWrapper.scss';

const delayDescriptor = {
  delay: { attachments: {} },
};
export class DelayViewWrapper extends React.Component {
  constructor(props) {
    super(props);
    const routerState = props.history.getState();
    this.state = {
      project: routerState ? routerState.project : null,
      delay: routerState ? routerState.delay : null,
      iconSrc: routerState ? routerState.iconSrc : null,
    };
    this.fetchDelay = this.fetchDelay.bind(this);
    this.handleActionCable = this.handleActionCable.bind(this);
  }

  componentDidMount() {
    dataModel.actionCableConnector.registerCallback(this.handleActionCable, ['updateDelay'], delayDescriptor);
    const delayId = this.props.match.params.delay_id;
    this.fetchDelay(delayId);
  }

  componentWillUnmount() {
    dataModel.actionCableConnector.unregisterCallback(this.handleActionCable, ['updateDelay']);
  }
  
  async fetchDelay(delayId) {
    const delay = await DataModel.delaysDAO.getDelay(delayId, { recordDescriptor: delayDescriptor });
    this.setState({ delay });
  }

  handleActionCable(fetchedData, acData) {
    this.setState({ delay: fetchedData });
  }

  render() {
    const { project, delay, iconSrc } = this.state;
    if (!project || !delay) {
      return null;
    }
    return (
      <div className="mobile-wrapper">
        <MobileHeader headerTitle={'Delay Details'} />
        <div className="content-wrapper delay-view-wrapper" id='view-wrapper'>
          <div className="delay-view-wrapper__heading">
            <ProjectDetailsHeader project={project} hideStatusBar={true} />
            <h4>{'REPORTED DELAY'}</h4>
          </div>
          <div className="delay-view-wrapper__content">
            <DelayReportContainer delay={delay} project={project} iconSrc={iconSrc}/>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DelayViewWrapper);



// WEBPACK FOOTER //
// ./src/mobileWrappers/DelayViewWrapper/index.js